import React from 'react'
import {Link} from 'react-router-dom';

function Error() {
  return (
    <div>Error

      <Link to="/">
        Return Home
      </Link>
    </div>
  )
}

export default Error